import React from "react";

import { Routes } from "Containers/Routes";
import { Layout } from "Containers/Layout";

import "./App.css";
import { Providers } from "./Providers";

function App() {
  return (
    <Providers>
      <Layout>
        <Routes />
      </Layout>
    </Providers>
  );
}

export default App;
